import { Output } from "valibot";

import { IntegrationHandler } from "shared/integrations";
import { LocaleSchema } from "shared/schemas";

import ZenDeskOrFreshDeskIntegration from "./ZenDeskIntegration";

export interface IChatIntegration {
  integration?: IntegrationHandler;
  generationLanguage: Output<typeof LocaleSchema>;
  botAvatar: string;
  chatId: string;
  token: string;
  onFinish?: (integration: IntegrationHandler) => void;
}

export default function Integration(props: IChatIntegration) {
  const {
    integration,
    generationLanguage,
    botAvatar,
    chatId,
    token,
    onFinish,
  } = props;
  if (!integration) {
    return null;
  }
  if (
    [
      "zendesk",
      "freshdesk",
      "zendesk_live_agent_handoff",
      "salesforce_leads",
      "salesforce_live_agent_handoff",
    ].includes(integration.type)
  ) {
    return (
      <ZenDeskOrFreshDeskIntegration
        botAvatar={botAvatar}
        generationLanguage={generationLanguage}
        integration={integration}
        chatId={chatId}
        token={token}
        onFinish={onFinish}
      />
    );
  }
  return <></>;
}
